<template>
	<create-edit-layout v-if="showCreateEditIncomeDeclarations" element="IncomeDeclarations" icon="fas fa-book" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12" align="right" class="py-0" v-if="currentIncomeDeclarations.id">
			<attachments-badge element="IncomeDeclarations" :label="$t('incomedeclarations.attachments')"></attachments-badge>
		</v-col>
		<v-col cols="12" xs="12" v-else>
			<upload-file vid="attachment" :helpinstruction="$t('incomedeclarations.uploadandreadinstruction')" :name="$t('incomedeclarations.attachments')" @fileuploaded="storeTempForUpload" :uploading="uploadattachment_loading" :types="['pdf', 'dat']"></upload-file>
		</v-col>
		<v-col cols="12" xs="12" sm="3">
			<ValidationProvider ref="ref_year" vid="ref_year" :name="$t('incomedeclarations.ref_year')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('incomedeclarations.ref_year')" v-model="currentIncomeDeclarations.ref_year" v-mask="'####'" :error-messages="errors"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<price-field vid="tax" :name="$t('incomedeclarations.tax')" rules="" v-model="currentIncomeDeclarations.tax"></price-field>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<price-field vid="contribute" :name="$t('incomedeclarations.contribute')" rules="" v-model="currentIncomeDeclarations.contribute"></price-field>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<price-field vid="taxable" :name="$t('incomedeclarations.taxable')" rules="" v-model="currentIncomeDeclarations.taxable"></price-field>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		uploadattachment_loading() {
			return this.$store.getters.uploadattachment_loading;
		},
		currentIncomeDeclarations: {
			get: function () {
				return this.$store.getters.getCurrentIncomeDeclarations;
			},
			set: function (value) {
				this.$store.commit("setCurrentIncomeDeclarations", value);
			},
		},
		showCreateEditIncomeDeclarations() {
			return this.$store.getters.showCreateEditIncomeDeclarations;
		},
		temporaryAttachment: {
			get: function () {
				return this.$store.getters.getTemporaryAttachment;
			},
			set: function (value) {
				this.$store.commit("setTemporaryAttachment", value);
			},
		},
	},
	methods: {
		storeTempForUpload(files) {
			this.formData = new FormData();
			this.formData.append("attachment", files[0]);
			this.$store.dispatch("readIncomeDeclarationFromFile", this.formData).then((res) => {
				if (res.object) {
					this.formData.append("index", 0);
					this.temporaryAttachment = [this.formData];
					let cloned = this.temporaryAttachment[0];
					if (res.file.title) {
						cloned.set("title", res.file.title);
					}
					this.temporaryAttachment[0] = cloned;
					this.temporaryAttachment = _.cloneDeep(this.temporaryAttachment);
				}
			});
		},
	},
};
</script>
